module.exports = __webpack_public_path__ + "img/grinning-face-with-big-eyes.d8630b30.png";